import React from 'react'
import { Box, Typography } from "@mui/material"
import { analyzerFilters, openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"
import { alpha } from "@mui/material/styles"

export default function AnalyzerHeaderTable({ label, columnKey, rowKey, rowValues, evolutionColumnValues }) {

	const handleOpenEvolutionModal = () => {
		openEvolutionModal.value = {
			filters: analyzerFilters.value,
			price_data: {
				[columnKey]: evolutionColumnValues[label][0][columnKey],
				[rowKey]: rowValues,
			},
			tableRows: evolutionColumnValues[label]
		}
	}

	return <TooltipSeeker title="Show Evolution Chart" key={label}>
		<Box
			sx={{
				my: 0.5,
				cursor: "pointer",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				transition: "background-color 0.3s ease",
				"&:hover .inner-box": {
					backgroundColor: alpha(dsColorNew.white, 0.12),
				}
			}}
			onClick={handleOpenEvolutionModal}
		>
			<Box
				className="inner-box"
				sx={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					gap: 0.3,
					padding: 0.5,
					px: 1,
					borderRadius: "6px",
					transition: "transform 0.3s ease",
				}}
			>
				<IconSeeker icon="magnifying-glass" sx={{ fontSize: 11, opacity: 0.8 }}/>
				<Typography sx={{ fontSize: 12, fontWeight: 600 }}>{label}</Typography>
			</Box>
		</Box>
	</TooltipSeeker>
}
